import VehicleReplacementListContainer from './VehicleReplacementListContainer';

export default VehicleReplacementListContainer;
